import {
  SET_ACCOUNT_CARD,
  SET_BALANCE_SHEET_DATA,
  SET_BANK_TRANSACTIONS,
  SET_BANK,
  SET_BUYS_BY_FACTOR,
  SET_BUY_BY_PRODUCTS,
  SET_CAPITALS,
  SET_CREDITORS_AND_DEBTORS,
  SET_FACTOR_PROFIT,
  SET_FACTOR_SUMMARY,
  SET_JOURNALS,
  SET_PRODUCT_CARD,
  SET_PROFIT_AND_LOSS,
  SET_REPORT,
  SET_REPORTS,
  SET_REPORT_TRANSACTIONS,
  SET_REVIEW_ACCOUNTS,
  SET_SALES_BY_FACTOR,
  SET_SALE_BY_PRODUCTS,
  SET_TAX_REPORT,
  SET_TRIAL_BALANCE,
  SET_USER_LOGS,
  SET_USER_CARD,
} from "../../constants/reportConstants";

export const setReport = (report) => {
  return {
    type: SET_REPORT,
    report,
  };
};

export const setReports = (reports) => {
  return {
    type: SET_REPORTS,
    reports,
  };
};
export const setBalanceSheetData = (balanceSheet) => {
  return {
    type: SET_BALANCE_SHEET_DATA,
    balanceSheet,
  };
};
export const setProfitAndLoss = (profitAndLoss) => {
  return {
    type: SET_PROFIT_AND_LOSS,
    profitAndLoss,
  };
};
export const setTrialBalance = (trialBalance, sumAmountFinal) => {
  return {
    type: SET_TRIAL_BALANCE,
    trialBalance,
    sumAmountFinal: sumAmountFinal
  };
};

export const setJournals = (journals, filtered = false) => {
  return {
    type: SET_JOURNALS,
    journals,
    filtered,
  };
};
export const setBankTransactions = (bankTransactions, filtered = false) => {
  return {
    type: SET_BANK_TRANSACTIONS,
    bankTransactions,
    filtered,
  };
};
export const setBankTransactionsBank = (bank) => {
  return {
    type: SET_BANK,
    bank,
  };
};
export const setReportTransactions = (reportTransactions, filtered = false) => {
  return {
    type: SET_REPORT_TRANSACTIONS,
    reportTransactions,
    filtered,
  };
};
export const setCapitals = (capitals, filtered = false) => {
  return {
    type: SET_CAPITALS,
    capitals,
    filtered,
  };
};
export const setReviewAccounts = (reviewAccounts, filtered = false) => {
  return {
    type: SET_REVIEW_ACCOUNTS,
    reviewAccounts,
    filtered,
  };
};
export const setCreditorsAndDebtors = (creditorsAndDebtors, filtered = false) => {
  return {
    type: SET_CREDITORS_AND_DEBTORS,
    creditorsAndDebtors,
    filtered,
  };
};
export const setTaxReport = (taxReport, filtered = false) => {
  return {
    type: SET_TAX_REPORT,
    taxReport,
    filtered,
  };
};

export const setSellByProducts = (saleByProducts, filtered = false) => {
  return {
    type: SET_SALE_BY_PRODUCTS,
    saleByProducts,
    filtered,
  };
};
export const setBuyByProducts = (buyByProducts, filtered = false) => {
  return {
    type: SET_BUY_BY_PRODUCTS,
    buyByProducts,
    filtered,
  };
};
export const setBuysByFactor = (buysByFactor, filtered = false) => {
  return {
    type: SET_BUYS_BY_FACTOR,
    buysByFactor,
    filtered,
  };
};
export const setSalesByFactor = (salesByFactor, filtered = false) => {
  return {
    type: SET_SALES_BY_FACTOR,
    salesByFactor,
    filtered,
  };
};

export const setFactorSummary = (factorSummary, filtered = false) => {
  return {
    type: SET_FACTOR_SUMMARY,
    factorSummary,
    filtered,
  };
};

export const setFactorProfit = (factorProfit, filtered = false) => {
  return {
    type: SET_FACTOR_PROFIT,
    factorProfit,
    filtered,
  };
};
export const setUserLogs = (userLogs, filtered = false) => {
  return {
    type: SET_USER_LOGS,
    userLogs,
    filtered,
  };
};

export const setAccountCard = (person, filtered = false) => {
  return {
    type: SET_ACCOUNT_CARD,
    person,
    filtered,
  };
};
export const setProductCard = (product, filtered = false) => {
  return {
    type: SET_PRODUCT_CARD,
    product,
    filtered,
  };
};
export const setUserCard = (user, filtered = false) => {
  return {
    type: SET_USER_CARD,
    user,
    filtered,
  };
};
